import React from 'react';

const ScreenMsg = () => {
  return ( 
    <div className="screen-msg-card">
      <span role="img" aria-label="annouce">📣</span> Please view on a screen wider than 800px💻 for optimal usage experience ✅
    </div>
   );
}
 
export default ScreenMsg;